import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_efvu4d6w47: FaireBrandEntity = {
  token: "b_efvu4d6w47",
  type: "brand",
  name: "KariKari",
  avatarUrl:
    "https://cdn.faire.com/fastly/7c441f0d97207ba62518d595e526cefcabcbf384808800f0d11d052b37303385.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/cd7e8611ce8ffa015bf2e303942578637b8113211bf8ff9a26de425db03d76ea.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7c441f0d97207ba62518d595e526cefcabcbf384808800f0d11d052b37303385.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cd7e8611ce8ffa015bf2e303942578637b8113211bf8ff9a26de425db03d76ea.jpeg",
  location: "Seattle, WA, USA",
  minimumOrderDollars: 108,
  rating: 5,
  reviewCount: 20,
  isTopShop: true,
  isInsider: true,
  description:
    "Crunchy. Spicy. Garlicky. Magic. \n\nMeet your new obsession: KariKari Chili Crisp. Overflowing with golden garlic, crispy shallots, and crunchy peanuts in rich chili oil, it’s bold, complex, and delivers a craveable crunch that transforms anything it touches.\n\nIf olive oil adds richness and hot sauce brings heat, KariKari brings the crunch — plus savory depth and that addictive “what is this and why is it so good?” factor. Handcrafted in small batches, it’s made for flavor lovers who want more out of every bite.\n\nThis isn’t just another condiment or sauce — it’s your kitchen’s MVP. The champion for all your snacks. Drizzle it over eggs, meats, seafood, noodles, sandwiches, pizza, rice bowls, tinned fish, roasted veg, even vanilla ice cream! Once you open a jar, there’s no going back!\n\nSpoon it. Sizzle it. Share it. Just don’t be surprised when you’re hooked!",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:18:07.301Z",
    importedBy: "entity-db-cli",
  },
};
